import { fetchAuthSession } from 'aws-amplify/auth';

/** トークンを取得する関数。 */
export const getIdToken = async () => {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString();
  } catch (error) {
    // トークン取得時のエラー
    throw error;
  }
};
